import {
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  useTheme,
} from '@mui/material';
import DataGridMAIQ from 'app/components/DataGridMAIQ';
import { useState } from 'react';
import DataGridTypes from 'types/DataGridTypes';
import DealerGroupDetailModal from './DealerGroupDetailModal';
import AddDealerGroupModal from './AddDealerGroupModal';
import { useDealerGroup } from '../../../../context/DealerGroupContext';
import BusinessIcon from '@mui/icons-material/Business';
import AddIcon from '@mui/icons-material/Add';

const DealershipGroupTab = () => {
  const { isEditing, setIsEditing } = useDealerGroup();
  const [isAddDealerGroupModal, setIsAddDealerGroupModal] = useState(false);
  const [isDealerGroupDetailsModalOpen, setIsDealerGroupDetailsModalOpen] =
    useState({
      data: {},
      status: false,
    });
  const [refreshKey, setRefreshKey] = useState(0); // Rerender key
  const theme = useTheme();

  const handleAddDealerGroupModalOpen = () => {
    setIsAddDealerGroupModal(true);
  };

  const handleCellClick = cell => {
    if (cell.field === 'name') {
      setIsDealerGroupDetailsModalOpen({
        data: cell.row,
        status: true,
      });
    }
  };

  const handleClose = () => {
    setIsEditing(false);
    setIsDealerGroupDetailsModalOpen({
      data: {},
      status: false,
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        height: '100%',
        padding: { xs: 1, sm: 2 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          borderRadius: 1.5,
          backgroundColor: 'background.paper',
          boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <BusinessIcon
            sx={{
              color: theme.palette.secondary.main,
              fontSize: 28,
            }}
          />
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: '1.1rem',
                color: theme.palette.secondary.main,
              }}
            >
              Dealership Group Management
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: '0.85rem' }}
            >
              Create and manage dealership groups
            </Typography>
          </Box>
        </Box>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleAddDealerGroupModalOpen}
          startIcon={<AddIcon />}
          sx={{
            borderRadius: 1,
            textTransform: 'none',
            fontWeight: 600,
            px: 2.5,
            py: 1,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
              backgroundColor: '#0a1f3a',
              boxShadow: '0 4px 10px rgba(15, 40, 76, 0.2)',
            },
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          Add Dealer Group
        </Button>
      </Paper>

      <Divider sx={{ opacity: 0.5 }} />

      <Box sx={{ flexGrow: 1, minHeight: 300 }}>
        <DataGridMAIQ
          key={refreshKey}
          type={DataGridTypes.DEALERS_GROUP_DATA()}
          onCellClick={handleCellClick}
        />
      </Box>

      <AddDealerGroupModal
        open={isAddDealerGroupModal}
        onClose={() => {
          setIsAddDealerGroupModal(false);
        }}
        setRefreshKey={setRefreshKey}
      />
      <DealerGroupDetailModal
        open={isDealerGroupDetailsModalOpen.status}
        onClose={handleClose}
        data={isDealerGroupDetailsModalOpen.data}
        setRefreshKey={setRefreshKey}
      />
    </Box>
  );
};

export default DealershipGroupTab;
